<template>
  <div v-if="loading" class="loadingoverlay">
    <br /><br /><br /><br /><br /><br /><br /><br />
    <div class="title" style="text-align: center">Loading...</div>
    <br />
    <div class="subtitle" style="text-align: center">
      Hang tight, this will just take a sec.
    </div>
    <img :src="require('@/assets/images/loading.gif')" alt="Loading" />
    <!-- <p>Nothing Happening? <a class="actionlink">Retry</a></p> -->
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  isFullPage: {
    type: Boolean,
    default: true,
  },
});
</script>
